import React from 'react'
import {Icon} from "@chakra-ui/react"
const SignInSvg = () => {
  return (
    <Icon boxSize="32px" mt="17px" mr="-4">
        <svg 
        height="11" 
        width="10"
        viewBox="0 0 10 11" 
        xmlns="http://www.w3.org/2000/svg" 
        className="commerce-button__avatar" 
        role="presentation">
        <path d="M5 5.295c-1.296 0-2.385-1.176-2.385-2.678C2.61 1.152 3.716 0 5 0c1.29 0 2.39 1.128 2.39 2.611C7.39 4.12 6.297 5.295 5 5.295zM1.314 11C.337 11 0 10.698 0 10.144c0-1.55 1.929-3.685 5-3.685 3.065 0 5 2.135 5 3.685 0 .554-.337.856-1.314.856z" fill="#fff">
        </path>
        </svg>
    </Icon>
  )
}

export default SignInSvg
